import { render, staticRenderFns } from "./order-create-payment.vue?vue&type=template&id=b02aaa68&"
import script from "./order-create-payment.ts?vue&type=script&lang=ts&"
export * from "./order-create-payment.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports